import { useEffect, useState, Fragment, useCallback } from "react";
import { t } from "i18next";
import {
  useGetLessonUtilizationByDaysQuery,
  useGetTrafficLightsQuery,
  useGetUtilizationChart3Query,
  useGetUtilizationQuery,
  useGetStatusClientsQuery,
} from "@/app/kpi/kpi.api";
import DescriptionHeadings from "@/shared/components/atoms/DescriptionHeadings";
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
import { parseDateUTC, formatDateTime } from "@/shared/utils/formatedDate";
import {
  colorsKpi,
  configureExporting,
  initializeAmChart,
  numberFormat,
} from "@/shared/utils/chartUtils";
import * as am5percent from "@amcharts/amcharts5/percent";
import LeadFormAddList from "@/shared/components/organisms/LeadFormAddList";
import LeadFormViewMore from "@/shared/components/organisms/LeadFormViewMore";
import { PaperClipIcon } from "@heroicons/react/20/solid";
import {
  faCloudArrowDown,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Select } from "@/shared/components/organisms/Select";
import { Option } from "@/shared/components/molecules/OptionsSelect";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { ButtonPrimary } from "@/shared/components/atoms/ButtonPrimary";
import { Modal } from "@/shared/components/organisms/Modal";
import { ModalXXL } from "@/shared/components/organisms/ModalXXL";
import { AgreementsTable } from "@/shared/components/organisms/AgreementsTable";

import {
  useSummaryExportMutation,
} from "@/app/summary/summary.api";

// Type
import { Branch } from "@/app/branchs/branchs.type";
import { CatchmentRequest } from "@/app/catchment/catchment.types";

export const initialValues: CatchmentRequest = {
  search: "",
  branch_filter: null,
  sex_filter: null,
  campaign_filter: null,
  stages_filter: null,
  stages_users_filter: null,
  tag_marketing_filter: null,
  catchment_page: "campaigns",
};

export type UtilizationOccupationProps = {
  branches: Branch[];
}

const UtilizationOccupationComponent: React.FC<UtilizationOccupationProps>  = ({branches}) => {
  const { data: getUtilization } = useGetUtilizationQuery({});
  const { data: statusClients } = useGetStatusClientsQuery({});
  const { data: getTrafficLights } = useGetTrafficLightsQuery({});
  const { data: getUtilizationChart3 } = useGetUtilizationChart3Query({});
  const [catchmentExport] = useSummaryExportMutation();
  const [formValues, setFormValues] = useState(initialValues);

  
  const [isKpisOpen, setIsKpisOpen] = useState(false);
  const [trafficLights, setTrafficLights] = useState<any>({});
  const [branchSelected, setBranchSelected] = useState<Option>();
  const [currencySelected, setCurrencySelected] = useState<Option>();
  const [optionsPrint, setOptionsPrint] = useState<[]>([]);
  const [optionsCurrencies, setOptionsCurrencies] = useState<Option[]>([]);

  //OPEN MODAL NOTAS
  const [openModalNotes, setOpenModalNotes] = useState(false);
  const handleOpenModalNotes = () => setOpenModalNotes(!openModalNotes);

  const [branchesOptions, setBranchesOptions] = useState<
    { id: number; name: string }[]
  >([]);

  const [branchSelectedView, setBranchSelectedView] = useState<Option>(() => {
    const saved = localStorage.getItem("branchSelectedView");
    return saved ? JSON.parse(saved) : undefined;
  });

  useEffect(() => {
    if (branchesOptions.length > 0 && !branchSelectedView) {
      setBranchSelectedView(branchesOptions[0]);
    }
  }, [branchesOptions, branchSelectedView]);

  const toggleKpis = useCallback(() => setIsKpisOpen((prev) => !prev), []);

  const optionsCursos = [
    { id: 1, name: t("user.views.select") },
    { id: 2, name: "Curso 1" },
    { id: 3, name: "Curso 2" },
  ];
  const [cursos, setCursos] = useState(optionsCursos[0]);

  useEffect(() => {
    if ( trafficLights && trafficLights[15]) {
      if (trafficLights[15].lesson_traffic_lights) {
        setOptionsPrint(trafficLights[15].lesson_traffic_lights.filter(
          (item: any) => item.branch_id === branchSelectedView?.id
        ));
      }
    }  
  }, [branchSelectedView, trafficLights]);

  useEffect(() => {
    if (branches) {
      setBranchesOptions(
        branches.map((branch: Branch) => ({
          id: branch.id,
          name: branch.branch,
        }))
      );
    }
  }, [branches]);

  useEffect(() => {
    setTrafficLights(getTrafficLights);
  
  }, [getTrafficLights]);

  useEffect(() => {
    if (getUtilization) {
      const dataChart1 = [
        {
          category: t("share.views.lessons_female"),
          value: getUtilization["chart1"][0]["totalAssist"],
        },
        {
          category: t("share.views.fitness_room_female"),
          value: getUtilization["chart1"][0]["totalAssistFitness"],
        },
        {
          category: t("share.views.lessons_male"),
          value: getUtilization["chart1"][1]["totalAssist"],
        },
        {
          category: t("share.views.fitness_room_male"),
          value: getUtilization["chart1"][1]["totalAssistFitness"],
        },
      ];
      utilizationChart1(dataChart1);
    }
  }, [getUtilization]);

  useEffect(() => {
    if (statusClients && statusClients.currency) {
      const currencyArray = Object.values(statusClients.currency);
      const currencies: Option[] = currencyArray.map((currency: any) => ({
        id: currency,
        name: currency,
      }));

      setOptionsCurrencies(currencies);
    }
  }, [statusClients]);

  function utilizationChart1(data: any) {
    am5.ready(function () {
      const root = initializeAmChart("chart_1");

      root.setThemes([am5themes_Animated.new(root)]);

      if (root._logo) {
        root._logo.dispose();
      }

      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          layout: root.verticalLayout,
          innerRadius: am5.percent(50),
        })
      );

      // Verifica que los datos no estén vacíos
      if (data.every((item: any) => item.value === 0)) {
        const label = root.container.children.push(
          am5.Label.new(root, {
            text: t("share.views.no_data"),
            fontSize: 20,
            fill: am5.color("#cbcac8"),
            centerX: am5.p50,
            centerY: am5.p50,
            x: am5.p50,
            y: am5.p50,
            horizontalCenter: "middle",
            verticalCenter: "middle",
          })
        );
        return;
      }

      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          valueField: "value",
          categoryField: "category",
          alignLabels: false,
        })
      );

      series.get("colors").set("colors", colorsKpi);

      series.data.setAll(data);

      series.slices.template.setAll({
        tooltipText: "{category}: {value}",
      });

      series.labels.template.setAll({
        textType: "circular",
        radius: 10,
        forceHidden: true,
      });

      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          marginTop: 15,
          marginBottom: 15,
        })
      );

      legend.data.setAll(series.dataItems);

      series.appear(1000, 100);
      configureExporting(root, data);
    });
  }

  useEffect(() => {
    if (getUtilizationChart3) {
      const seriesData = Object.entries(getUtilizationChart3["chart"]).map(
        ([key, value]) => ({
          name: key,
          data: (value as { date: string; total: number }[]).map((item) => ({
            category: item.date,
            value: item.total,
          })),
        })
      );
      utilizationChart2(seriesData, getUtilizationChart3["dates"]);
    }
  }, [getUtilizationChart3]);

  function utilizationChart2(seriesData: any, dates: any) {
    am5.ready(function () {
      const root = initializeAmChart("chart_3");

      root.setThemes([am5themes_Animated.new(root)]);

      if (root._logo) {
        root._logo.dispose();
      }

      if (
        seriesData.every((series: any) =>
          series.data.every((dataItem: any) => dataItem.value === 0)
        )
      ) {
        const label = root.container.children.push(
          am5.Label.new(root, {
            text: t("share.views.no_data"),
            fontSize: 20,
            fill: am5.color("#cbcac8"),
            centerX: am5.p50,
            centerY: am5.p50,
            x: am5.p50,
            y: am5.p50,
            horizontalCenter: "middle",
            verticalCenter: "middle",
          })
        );
        return;
      }
      const categories = dates;

      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: true,
          panY: true,
          wheelX: "panX",
          wheelY: "zoomX",
          pinchZoomX: true,
          layout: root.verticalLayout,
        })
      );
      // Desacticonst el zoom
      chart.set("panX", false);
      chart.set("panY", false);
      chart.set("wheelX", "none");
      chart.set("wheelY", "none");
      chart.set("pinchZoomX", false);
      chart.set("pinchZoomY", false);
      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          marginTop: 15,
          marginBottom: 15,
          layout: root.horizontalLayout, // Cambiar a verticalLayout si es necesario
        })
      );

      legend.labels.template.setAll({
        fontSize: 10,
        fontWeight: "300",
        textAlign: "left",
      });

      // Ajustar espaciado entre entradas de leyenda
      legend.itemContainers.template.setAll({
        marginTop: 5, // Espacio entre las entradas de leyenda
        marginBottom: 5,
      });

      // Ajustar espaciado alrededor de la leyenda
      legend.setAll({
        marginLeft: 30, // Espacio a la izquierda de la leyenda
        marginRight: 30, // Espacio a la derecha de la leyenda
      });

      const xRenderer = am5xy.AxisRendererX.new(root, {
        cellStartLocation: 0.1,
        cellEndLocation: 0.9,
        minorGridEnabled: true,
        minGridDistance: 10,
      });

      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "category",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {}),
        })
      );

      xRenderer.grid.template.setAll({
        location: 1,
        visible: false,
      });

      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {}),
        })
      );

      xAxis.data.setAll(
        categories.map((category: any) => ({
          category,
        }))
      );

      seriesData.forEach((seriesItem: any, index: any) => {
        const series = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: seriesItem.name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "value",
            categoryXField: "category",
            stacked: false,
            fill: am5.color(colorsKpi[index % colorsKpi.length]),
          })
        );

        series.data.setAll(seriesItem.data);

        series.columns.template.setAll({
          tooltipText: "{name}, {category}: {valueY}",
          width: am5.percent(90),
          fillOpacity: 0.8,
          fontSize: "0.8rem",
        });

        legend.data.push(series);
      });

      chart.appear(1000, 100);

      configureExporting(root, seriesData);
    });
  }

  const { data: getLessonUtilizationByDaysQuery } =
    useGetLessonUtilizationByDaysQuery(false);

  useEffect(() => {
    if (getLessonUtilizationByDaysQuery) {
      const seriesData = getLessonUtilizationByDaysQuery["data"];
      const days = getLessonUtilizationByDaysQuery["days"];

      const data: any = [];
      seriesData.forEach((seriesItem: any) => {
        seriesItem.data.forEach((value: any, index: any) => {
          if (!data[index]) {
            data[index] = {
              category: days[index],
            };
          }
          data[index][seriesItem.local] = value;
        });
      });

      utilizationChart3(data, seriesData);
    }
  }, [getLessonUtilizationByDaysQuery]);

  function utilizationChart3(data: any, seriesData: any) {
    am5.ready(function () {
      const root = initializeAmChart("chart_utilization_days");

      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          layout: root.verticalLayout,
          panX: true,
          panY: true,
          wheelX: "panX",
          wheelY: "zoomX",
          pinchZoomX: true,
        })
      );

      if (root._logo) {
        root._logo.dispose();
      }

      const isValid =
        Array.isArray(seriesData) &&
        seriesData.every(
          (item) =>
            typeof item === "object" &&
            item !== null &&
            "local" in item &&
            "data" in item &&
            Array.isArray(item.data) &&
            item.data.every((value: any) => value === 0)
        );

      const emptyLabel = root.container.children.push(
        am5.Label.new(root, {
          text: t("share.views.no_data"),
          fontSize: 20,
          fill: am5.color("#cbcac8"),
          centerX: am5.p50,
          centerY: am5.p50,
          x: am5.p50,
          y: am5.p50,
          horizontalCenter: "middle",
          verticalCenter: "middle",
        })
      );

      const seriesMap = {};
      // Disable zoom
      chart.setAll({
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        pinchZoomX: false,
        pinchZoomY: false,
      });

      const xRenderer = am5xy.AxisRendererX.new(root, {
        cellStartLocation: 0.1,
        cellEndLocation: 0.9,
        minorGridEnabled: true,
        minGridDistance: 10,
      });

      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: "category",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {}),
        })
      );

      xRenderer.grid.template.setAll({
        location: 1,
        visible: false,
      });

      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {}),
        })
      );

      xAxis.data.setAll(
        data.map((item: any) => ({
          category: item.category,
        }))
      );

      seriesData.forEach((seriesItem: any, index: any) => {
        const series = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: seriesItem.local,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: seriesItem.local,
            categoryXField: "category",
            stacked: false,
            fill: am5.color(colorsKpi[index % colorsKpi.length]),
          })
        );

        series.data.setAll(data);

        series.columns.template.setAll({
          tooltipText: "{name}: {valueY}",
          width: am5.percent(80),
          fillOpacity: 0.8,
          cornerRadius: 10,
        });

        seriesMap[seriesItem.local] = series;
      });

      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          layout: root.horizontalLayout,
          marginTop: 15,
          marginBottom: 15,
        })
      );

      legend.labels.template.setAll({
        fontSize: 10,
        fontWeight: "300",
      });

      legend.data.setAll(chart.series.values);
      chart.appear(1000, 100);
    });
  }

  const optionsBranch = [
    { id: 1, name: "Demo GYM" },
    { id: 2, name: "Test GYM" },
    { id: 3, name: "Fitmewise GYM" },
  ];

  const handleSubmit = () => {};

  const [formData, setFormData] = useState({
    nombre: "",
    date: "",
    time: "",
    men_utilization: [],
    women_utilization: [],
  });

  const setOnOpenAddProduct = () => {
    //setToggleNewLeadModal(!toggleNewLeadModal);
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    
    const { name, value } = event.target;

    console.log(name, value);
    
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [agreementsVisible, setAgreementsVisible] = useState(false);

  const [toggleNewLeadModal, setToggleNewLeadModal] = useState(false);
  const [toggleViewMore, setToggleViewMore] = useState(false);

  const [errors, setErrors] = useState({
    nombre: "",
    linkPrivacidad: false,
    linkTerminos: false,
    linkSitio: false,
    fileUpload: false, // Para el archivo
  });

  const [selectedOptionBranch, setSelectedOptionBranch] = useState(
    optionsBranch[0]
  );

  const handleExport = async () => {
    try {
      const response = await catchmentExport({
        ...formValues,
      }).unwrap();

      // Crear un blob con el tipo de contenido correcto
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "compliance.csv"); // Nombre del archivo
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Liberar el objeto URL después de la descarga
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting catchment:", error);
    }
  };

  return (
    <>
      {" "}
      <div className="p-4">
        <DescriptionHeadings
          title={t("user.views.main_message13")}
          description={t("user.views.usage_and_occupation_description")}
        />
      </div>
      <div className="grid grid-cols-12 gap-4 p-4">
        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-6">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900  text-center">
              {t("user.views.main_message14")}
            </h4>
          </div>
          <div className="chart">
            <div id="chart_1" style={{ width: "100%", height: "400px" }}></div>
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-6 flex flex-col min-h-screen">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("compliance.compliance_objective_average")}
            </h4>
          </div>

          {trafficLights && trafficLights[15] && (
            <div
              className= {`body flex flex-col h-full items-center
                ${trafficLights[15]["lesson_traffic_lights_average"] > 1 ? 'justify-end' : 'justify-center' } min-h-80 pb-12 flex-grow`}
            >
              {
                trafficLights[15]["lesson_traffic_lights_average"] > 1 ? (
                  <div
                    className="relative w-1/2"
                    style={{
                      height: `${trafficLights[15]["lesson_traffic_lights_average"]}%`,
                      background:
                        trafficLights[15]["lesson_traffic_lights_average_color"],
                    }}
                  >
                    <p className="absolute bottom-0 left-0 right-0 w-full text-center text-2xl font-bold">
                      {numberFormat(
                        trafficLights[15]["lesson_traffic_lights_average"],
                        0,
                        ".",
                        ""
                      )}
                      %
                    </p>
                  </div>
                ) : (
                  <div
                    className="relative w-full"
                  >
                    <div className="absolute top-0 left-0 right-0 w-full text-center text-[#cbcac8] text-xl">
                      {t("share.views.no_data")}
                    </div>
                  </div>
                )
              }
            </div>
          )}
          <div className="footer mt-auto">
            <ButtonPrimary
              size="medium"
              text={t("compliance.compliance_objective_detail_label")}
              onClick={() => setAgreementsVisible(!agreementsVisible)}
            />
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-12 flex flex-col min-h-screen">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("user.views.main_message16")}
            </h4>
          </div>
          <div className="chart">
            <div id="chart_3" style={{ width: "100%", height: "400px" }}></div>
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-12 flex flex-col min-h-screen">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("user.views.occupation_lesson_title")}
            </h4>
          </div>

          <div className="footer">
            <ButtonPrimary
              size="medium"
              text={t("user.views.occupation_lesson_button")}
              onClick={() => {
                setToggleNewLeadModal(!toggleNewLeadModal);
              }}
            />
          </div>

          {isKpisOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center">
              <div
                className="fixed inset-0 bg-black opacity-50"
                onClick={toggleKpis}
              ></div>
              <div className="relative bg-white w-full max-w-4xl p-8 shadow-xl rounded-lg">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
                  
                  <div className="col-span-2 mt-5">
                    <button className="btn btn-fmw font-weight-bold w-full" id="add_ocuppation">
                      {t("user.views.occupation_lesson_room_button")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="chart">
            <div
              id="chart_utilization_days"
              style={{ width: "100%", height: "400px" }}
            ></div>
          </div>
        </div>

        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-12 flex flex-col mt-5">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("user.views.client_list_by_activity")}
            </h4>
          </div>
          <div className="flex flex-wrap gap-4 w-full border py-10 px-10">         
            <Select
              name=""
              options={optionsCurrencies}
              tittle={t("store.views.form.currency")}
              selected={currencySelected}
              setSelected={setCurrencySelected}
            />
            <Select
              name="branch"
              selected={branchSelected}
              setSelected={setBranchSelected}
              options={branchesOptions}
              tittle={t("user.views.branch")}
            />
            <DateRangePicker
              label={`${t("user.views.period")}`}
              id="2"
              value={{
                startDate: parseDateUTC(new Date().toISOString().split("T")[0]),
                endDate: parseDateUTC(new Date().toISOString().split("T")[0]),
              }}
              onDateChange={(startDate: Date, endDate: Date) => {
                // Se agrega la funcion para cuando cambie la fecha
              }}
            />
            <div className="relative bottom-0">
              <button
                type="button"
                onClick={() => {}}
                className="mt-8 text-gray-400 hover:text-gray-500 hidden md:block"
              >
                <span className="sr-only">View KPIs</span>
                <FontAwesomeIcon
                  icon={faCloudArrowDown}
                  aria-hidden="true"
                  className="h-8 w-8"
                />
              </button>
            </div>
          </div>
          <div className="w-full">
          <Fragment>
            <table className="min-w-full border-y border-gray-500 divide-y divide-gray-300 my-5 ">
              <thead className="">
                <tr>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {t("user.views.user")}
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {t("brand.views.marketing_tags")}
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {t("user.views.training_created_by")}
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {t("user.views.nutrition_created_by")}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                
              </tbody>
            </table>
          </Fragment>
          </div>
        </div>

        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-12 flex flex-col mt-5">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("user.views.client_list_by_professional_service")}
            </h4>
          </div>
          <div className="flex flex-wrap gap-4 w-full border py-10 px-10">         
            <Select
              name=""
              options={optionsCurrencies}
              tittle={t("user.views.main_message26")}
              selected={currencySelected}
              setSelected={setCurrencySelected}
            />
            <Select
              name="branch"
              selected={branchSelected}
              setSelected={setBranchSelected}
              options={branchesOptions}
              tittle={t("user.views.branch")}
            />
            <DateRangePicker
              label={`${t("user.views.period")}`}
              id="2"
              value={{
                startDate: parseDateUTC(
                  new Date().toISOString().split("T")[0]
                ),
                endDate: parseDateUTC(
                  new Date().toISOString().split("T")[0]
                ),
              }}
              onDateChange={(startDate: Date, endDate: Date) => {
                // Se agrega la funcion para cuando cambie la fecha
              }}
            />
            <div className="relative bottom-0">
              <button
                type="button"
                onClick={() => {}}
                className="mt-8 text-gray-400 hover:text-gray-500 hidden md:block"
              >
                <span className="sr-only">View KPIs</span>
                <FontAwesomeIcon
                  icon={faCloudArrowDown}
                  aria-hidden="true"
                  className="h-8 w-8"
                />
              </button>
            </div>
          </div>
          <div className="w-full">
            <Fragment>
              <table className="min-w-full border-y border-gray-500 divide-y divide-gray-300 my-5 ">
                <thead className="">
                  <tr>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("user.views.user")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("brand.views.marketing_tags")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("user.views.training_created_by")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("user.views.nutrition_created_by")}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  
                </tbody>
              </table>
            </Fragment>
          </div>
        </div>

        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-12 flex flex-col mt-5">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("user.views.client_list_by_course")}
            </h4>
          </div>
          <div className="flex flex-wrap gap-4 w-full border py-10 px-10">         
            <Select
              name="cursos"
              tittle={t("course.views.courses")}
              selected={cursos}
              setSelected={setCursos}
              options={optionsCursos}
            />
            <Select
              name="branch"
              selected={branchSelected}
              setSelected={setBranchSelected}
              options={branchesOptions}
              tittle={t("user.views.branch")}
            />
            <DateRangePicker
              label={`${t("user.views.period")}`}
              id="2"
              value={{
                startDate: parseDateUTC(
                  new Date().toISOString().split("T")[0]
                ),
                endDate: parseDateUTC(
                  new Date().toISOString().split("T")[0]
                ),
              }}
              onDateChange={(startDate: Date, endDate: Date) => {
                // Se agrega la funcion para cuando cambie la fecha
              }}
            />
            <div className="relative bottom-0">
              <button
                type="button"
                onClick={() => {}}
                className="mt-8 text-gray-400 hover:text-gray-500 hidden md:block"
              >
                <span className="sr-only">View KPIs</span>
                <FontAwesomeIcon
                  icon={faCloudArrowDown}
                  aria-hidden="true"
                  className="h-8 w-8"
                />
              </button>
            </div>
          </div>
          <div className="w-full">
            <Fragment>
              <table className="min-w-full border-y border-gray-500 divide-y divide-gray-300 my-5 ">
                <thead className="">
                  <tr>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("user.views.user")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("brand.views.marketing_tags")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("user.views.training_created_by")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("user.views.nutrition_created_by")}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  
                </tbody>
              </table>
            </Fragment>
          </div>
        </div>

        <LeadFormAddList
          handleSubmit={handleSubmit}
          setToggleNewLeadModal={setToggleNewLeadModal}
          toggleNewLeadModal={toggleNewLeadModal}
          formData={formData}
          handleChange={handleChange}
          errors={errors}
          selectedOptionBranch={selectedOptionBranch}
          setSelectedOptionBranch={setSelectedOptionBranch}
          optionsBranch={optionsBranch}
          OnOpenAddProduct={setOnOpenAddProduct}
        />

        { trafficLights && trafficLights[15] && (
          <LeadFormViewMore
            dataprint={optionsPrint}
            openModal={handleOpenModalNotes}
            handleSubmit={handleSubmit}
            handleExport={handleExport}
            setToggleNewLeadModal={setToggleViewMore}
            toggleNewLeadModal={toggleViewMore}
            formData={formData}
            handleChange={handleChange}
            errors={errors}
            selectedOptionBranch={selectedOptionBranch}
            setSelectedOptionBranch={setSelectedOptionBranch}
            optionsBranch={optionsBranch}
            branches={branches}
            branchSelected={branchSelectedView}
            setBranchSelected={setBranchSelectedView}
          />
        )}
      </div>

      <Modal
        open={openModalNotes}
        Close={handleOpenModalNotes}
        tittleModal={'Definir porcentajes de ocupación para el semáforo'}

      >
        <form action="#" className="relative mt-4">
          <div className="mt-4 grid grid-cols-1 gap-4 px-20">
            <div>
              <label htmlFor="gray" className="block text-sm font-medium text-gray-700">
                Gris
              </label>
              <input
                type="number"
                id="gray"
                name="gray"
                disabled
                defaultValue={0}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="red" className="block text-sm font-medium text-gray-700">
                Rojo
              </label>
              <input
                type="number"
                id="red"
                name="red"
                defaultValue={60}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="yellow" className="block text-sm font-medium text-gray-700">
                Amarillo
              </label>
              <input
                type="number"
                id="yellow"
                name="yellow"
                defaultValue={70}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="green" className="block text-sm font-medium text-gray-700">
                Verde
              </label>
              <input
                type="number"
                id="green"
                name="green"
                defaultValue={90}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          </div>

          <div className="w-full flex justify-end mt-5">
            <ButtonPrimary
              text={'Aceptar'}
              size="small-xs"
              onClick={handleOpenModalNotes}
            />
          </div>          


        </form>
      </Modal>

      {optionsPrint && (
        <ModalXXL
          open={agreementsVisible}
          Close={() => setAgreementsVisible(false)}
          tittleModal={t("Detalle del objetivo de ocupación de actividades dirigidas")}
          textButtonCreate={t("general.create")}
          textButtonClose={t("general.cancel")}
          handleExport={handleExport}
          openModal={handleOpenModalNotes}

          branchesOptions={branchesOptions}
          branches={branches}
          branchSelected={branchSelectedView}
          setBranchSelected={setBranchSelectedView}
        >
          <div className="mt-0 mx-2">
            <div className="space-y-12">
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                <div className="grid max-w-6xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-3">
                  <div className="col-span-full flex space-x-4">
                    <table className="min-w-full divide-y divide-gray-300 bg-white">
                      <thead>
                        <tr>
                          <th className="p-4 text-left text-sm font-semibold text-gray-900">
                            {t("compliance.table_name")}
                          </th>
                          <th className="p-4 text-left text-sm font-semibold text-gray-900">
                            {t("compliance.table_time")}
                          </th>
                          <th className="p-4 text-left text-sm font-semibold text-gray-900">
                            {t("compliance.table_from")}
                          </th>
                          <th className="p-4 text-left text-sm font-semibold text-gray-900">
                            {t("compliance.table_to")}
                          </th>
                          <th className="p-4 text-left text-sm font-semibold text-gray-900">
                            {t("compliance.table_specialist")}
                          </th>
                          <th className="p-4 text-center text-sm font-semibold text-gray-900">
                            {t("compliance.average_rating")}
                          </th>
                          <th className="p-4 text-center text-sm font-semibold text-gray-900">
                            {t("compliance.table_percent")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {optionsPrint.map((data: any, index: number) => (
                          <tr key={index} className="bg-white">
                            <td className="p-4 text-sm font-medium text-gray-500">
                              {data.name}
                            </td>
                            <td className="p-4 text-sm font-medium text-gray-500">
                              <div className="flex gap-2">
                                <span>{data.inital_of_day}</span>
                                <span>({data.time_start},</span>
                                <span>{data.duration}min)</span>
                              </div>
                            </td>
                            <td className="px-4 text-sm font-medium text-gray-500 whitespace-nowrap overflow-hidden">
                              {formatDateTime(data.start_date_time)}
                            </td>
                            <td className="px-4 text-sm font-medium text-gray-500 whitespace-nowrap overflow-hidden">
                              {formatDateTime(data.end_date_time)}
                            </td>
                            <td className="px-4 text-sm font-medium text-gray-500">
                              {data.specialists}
                            </td>
                            <td className="px-4 text-center text-sm font-medium text-gray-500">
                              <div className="flex justify-center w-full">
                                <span
                                  className="flex items-center justify-center h-11 w-11 text-white rounded-md"
                                  style={{ background: data.color }}
                                >
                                  {Number(data.average_rating).toFixed(0)}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 text-center text-sm font-medium text-gray-500">
                              <div className="flex justify-center w-full">
                                <span
                                  className="flex items-center justify-center h-11 w-11 text-white rounded-md"
                                  style={{ background: data.color }}
                                >
                                  {Number(data.total_attendance).toFixed(0)}%
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalXXL>
      )}
      

    </>
  );
};

export default UtilizationOccupationComponent;
